// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import panel from 'eruda';
// 引入 es6
import 'babel-polyfill';
import 'es6-promise/auto';

// 样式管理
import 'mint-ui/lib/style.css';
import '@/assets/base.less';

// 引入 vue
import Vue from 'vue';

// vue 插件
import VuePreview from '@/components/preview/index';
import ScoreLabel from '@/components/ScoreLabel';
import MintUI from 'mint-ui';
import VueTouch from 'vue-touch';

// 处理点击连接延迟
import FastClick from 'fastclick';
import Cookies from 'js-cookie';

// 埋点
import { Track, TrackLisener } from '@bbt/mt-utils-tracking';

// 特性检查，cookie 工具方法
import { browser } from '@/lib/ua';
import auth from '@/lib/auth';

// vue 配置文件
import App from './App';
import router from './router';
import store from '../store';
// import config from './config';
import * as actions from '../store/actions';
import '../lib/performance-polyfill';

/* // 远程调试
// eslint-disable-next-line
import panel from 'eruda';
panel.init();
 */
// 关闭生产模式下给出的提示
Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm) => {
  console.error(err, vm);
};

// 给页面增加click埋点事件.
TrackLisener.addClickListenner();
window.Track = Track;
window.Tracking = {
  initTrackUrl: (logEvent, trackCode, toHref, orderNo, tCode) => {
    Track.doTracker(logEvent, trackCode, toHref, orderNo, tCode);
  }
};


FastClick.attach(document.body);

if (browser.wx) {
  const wx = require('weixin-js-sdk'); // eslint-disable-line global-require
  window.wx = wx;
}

router.beforeEach((to, from, next) => {
  // 设置 title
  document.title = (to.query && decodeURIComponent(to.query.pageTitle || '')) || (to.meta && to.meta.pageTitle) || '开讲';
  const type = 'user';
  const code = to.query.code;
  // 大健康签名
  if (!from.name) {
    const fxCode = to.query.code;
    const userInfo = auth.get();
    if (userInfo) {
      let userSource = 1;  // userSource = 0 表示页面从网红医生进入
      const hasOpenId = userInfo.weixinUserInfo ? userInfo.weixinUserInfo.openid : 0;
      if (userInfo.userSource === 0) {
        userSource = 0;
      }
      if (userSource === 0 && fxCode && browser.wx && !hasOpenId) {
        store.dispatch('userAuth', {
          code: to.query.code
        });
      } else {
        store.dispatch('userAuth', { userInfo });
      }
    } else if (fxCode) {
      let platformType = 5;
      if (to.name === 'dayimaVerify' && !/huawei/i.test(navigator.userAgent)) { // dayima 带过来的使用 专家答公众号授权
        platformType = process.env.PROJECT_BUILD_ENV === 'production' ? 13 : 12;
      }
      store.dispatch('userAuth', {
        code: fxCode,
        platformType
      });
    } else {
      store.dispatch('userAuth', {});
    }
  }

  // 登录校验
  if (to.meta.requiresAuth) {
    if (!auth.check('user')) {
      if (to.name === 'dayimaVerify' && !/huawei/i.test(navigator.userAgent)) { // 走dayima的授权获取code  华为手机走正常授权
        auth.login('dayima', code, next);
      } else {
        auth.login(type, code, next);
      }
      return;
    }
    // 绑定手机校验
    const userInfo = auth.get();
    if (to.name === 'UserBinding' && userInfo) {
      // 已绑定手机号无法打开绑定手机页面
      if (Number(userInfo.isHaveMobile) === 1) {
        next('/');
      }
    }

    // 2018-11-12新增如果 app 内 返回的值与cookie 的值不一致，更新userinfo
    if (userInfo && Cookies.get('userInfo')
      && (userInfo.token !== Cookies.get('userInfo').token
          || userInfo.encUserId !== Cookies.get('userInfo').encUserId)) {
      store.dispatch('userAuth', { userInfo });
    }
  }

  if (from.query.hideHeaderHome) {
    to.query.hideHeaderHome = from.query.hideHeaderHome;
  }
  if (from.query.hideHeaderRight) {
    to.query.hideHeaderRight = from.query.hideHeaderRight;
  }
  if (from.query.hideDesc) {
    to.query.hideDesc = from.query.hideDesc;
  }
  if (from.query.hideVip) {
    to.query.hideVip = from.query.hideVip;
  }

  next();
});

const courseReg = new RegExp('/info/');
router.afterEach((route) => {
  if (browser.wx) {
    // 如果当前URL 没有 info路径，并且又是课程类型，重新跳转
    if (route.meta.isCourse && !courseReg.test(location.href)) {
      location.href = `${location.origin}/live${route.fullPath}`;
    } else {
      // window.__wxjs_is_wkwebview  是不是同的浏览器内核
      // true 时 为 IOS 设备
      // false时 为 安卓 设备
      const type = route.meta.authType;

      if (window.__wxjs_is_wkwebview) { // eslint-disable-line
        if (window.entryUrl === '' || window.entryUrl === undefined) {
          const url = `${location.origin}/live${route.fullPath}`;
          window.entryUrl = url; // 将后面的参数去除
        }
        actions.wxSign(store, {
          url: window.entryUrl,
          debug: false, // from.query.debug,
          type
        });
      } else {       // 安卓
        setTimeout(() => {
          actions.wxSign(store, {
            url: `${location.origin}/live${route.fullPath}`,
            debug: false, // from.query.debug,
            type
          });
        }, 500);
      }
    }
  }
});

/**
 * author: jialong
 * date: 2018/11/8
 * description: 因为mint-ui toast不会互斥 故二次封装toast
 * @param {*} toastInfo
 */
const Toast = MintUI.Toast;
let Timer = null;
const toastObj = {
  toasting: false,
  lastDuration: 0
};
function toast(toastInfo) {
  let message = '';
  let duration = 3000;
  let position = 'middle';
  if (typeof toastInfo === 'object') {
    message = toastInfo.message;
    duration = toastInfo.duration || duration;
    position = toastInfo.position || position;
  } else {
    message = String(toastInfo);
  }
  if (toastObj.toasting) {
    if (Timer) {
      return;
    }
    Timer = setTimeout(() => {
      Toast({ message, duration, position });
      Timer = null;
    }, toastObj.lastDuration);
  } else {
    Toast({ message, duration, position });
    toastObj.toasting = true;
    toastObj.lastDuration = duration;
    setTimeout(() => {
      toastObj.toasting = false;
      toastObj.lastDuration = 0;
    }, duration);
  }
}
window.toast = toast;


// 定义过滤器，
Vue.filter('time', timestamp => (new Date(timestamp).toLocaleTimeString()));

// TODO: 框架中没有使用到 VueResource，可以考删掉
// Vue.use(VueResource);
Vue.use(MintUI);
Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(VuePreview);
Vue.component('ScoreLabel', ScoreLabel);

// 2017-11-09 增加调整根字体大小
document.documentElement.style.fontSize = `${document.documentElement.clientWidth / 18.75}px`;
/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

// panel.init();



// WEBPACK FOOTER //
// ./src/user/main.js